import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48a4c671"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-items-length"]
const _hoisted_2 = { class: "g-home-block_footer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "fontisto:telegram",
    "clip-path": "url(#clip0_6710_15655)"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector",
      d: "M12.5 0C5.873 0 0.5 5.373 0.5 12C0.5 18.627 5.873 24 12.5 24C19.127 24 24.5 18.627 24.5 12C24.5 5.373 19.127 0 12.5 0ZM18.394 8.221L16.424 17.501C16.279 18.159 15.887 18.319 15.34 18.009L12.34 15.799L10.894 17.193C10.8231 17.2847 10.7322 17.359 10.6282 17.4101C10.5242 17.4613 10.4099 17.4879 10.294 17.488H10.289L10.502 14.434L16.062 9.412C16.302 9.199 16.008 9.078 15.689 9.291L8.82 13.617L5.86 12.693C5.22 12.49 5.202 12.053 5.995 11.739L17.561 7.281C18.099 7.085 18.567 7.409 18.393 8.222L18.394 8.221Z",
      fill: "#fff"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_6710_15655" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.5)"
      })
    ])
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.50049 16.5001C1.50049 13.1863 4.18678 10.5001 7.50049 10.5001C10.8142 10.5001 13.5005 13.1863 13.5005 16.5001H1.50049ZM7.50049 9.75006C5.01424 9.75006 3.00049 7.73631 3.00049 5.25006C3.00049 2.76381 5.01424 0.750061 7.50049 0.750061C9.98674 0.750061 12.0005 2.76381 12.0005 5.25006C12.0005 7.73631 9.98674 9.75006 7.50049 9.75006ZM13.0226 11.425C15.3366 12.0163 17.0764 14.0427 17.2382 16.5001H15.0005C15.0005 14.5427 14.2506 12.7605 13.0226 11.425ZM11.5056 9.71774C12.7301 8.61921 13.5005 7.02461 13.5005 5.25006C13.5005 4.18706 13.224 3.18862 12.7392 2.32271C14.457 2.66554 15.7505 4.18105 15.7505 6.00006C15.7505 8.07194 14.0724 9.75006 12.0005 9.75006C11.8327 9.75006 11.6675 9.73904 11.5056 9.71774Z",
    fill: "#fff"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_club_article = _resolveComponent("club-article")!
  const _component_ac_button = _resolveComponent("ac-button")!
  const _component_home_block = _resolveComponent("home-block")!
  const _component_modal_choose_club = _resolveComponent("modal-choose-club")!

  return (_ctx.isShowClubBlock)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_home_block, {
          class: "g-home-block home-club",
          "show-info-btn": _ctx.showInfo,
          "is-loaded": _ctx.loaded && _ctx.previewLoaded,
          "items-count": _ctx.articles.length,
          "show-all-btn": _ctx.showAll,
          "current-item-index": _ctx.navigation.currentIndex,
          "onClick:info": _ctx.handlerClubFaq,
          "onNav:all": _ctx.handlerClubLookAll,
          "onNav:prev": _ctx.navigation.prev,
          "onNav:next": _ctx.navigation.next,
          "is-disabled-prev": _ctx.navigation.isDisabledPrev,
          "is-disabled-next": _ctx.navigation.isDisabledNext
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", {
              class: "home-club_link",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlerClubLookAll && _ctx.handlerClubLookAll(...args)))
            }, _toDisplayString(_ctx.$t('Community')), 1)
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", {
              class: "g-home-block_wrapper",
              ref: "refContainer",
              onWheel: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigation.onScrollWrapper && _ctx.navigation.onScrollWrapper(...args))),
              "data-items-length": _ctx.articles.length
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
                return (_openBlock(), _createBlock(_component_club_article, {
                  key: article.id,
                  article: article,
                  class: "home-club_article g-home-block_item"
                }, null, 8, ["article"]))
              }), 128))
            ], 40, _hoisted_1)
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.isHaveClubSubscribe)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.showChat)
                      ? (_openBlock(), _createBlock(_component_ac_button, {
                          key: 0,
                          class: "home-club_btn --chat-btn",
                          onClick: _ctx.handlerClubChat
                        }, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('chatOfClubMembers')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_ctx.showAboutClub)
                  ? (_openBlock(), _createBlock(_component_ac_button, {
                      key: 1,
                      class: "home-club_btn",
                      onClick: _ctx.handlerAboutClub
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('whatIsClub')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["show-info-btn", "is-loaded", "items-count", "show-all-btn", "current-item-index", "onClick:info", "onNav:all", "onNav:prev", "onNav:next", "is-disabled-prev", "is-disabled-next"]),
        _createVNode(_component_modal_choose_club, {
          modelValue: _ctx.showModalChooseClub,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModalChooseClub) = $event)),
          communities: _ctx.communitiesModalChooseClub,
          onChooseClub: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handlerChooseClub($event)))
        }, null, 8, ["modelValue", "communities"])
      ], 64))
    : _createCommentVNode("", true)
}